import React from 'react'
import { Link } from 'react-router-dom'

const Banner = ({banner}) => {
  return (
    <div className="container pt-80 pb-80  padt padb ">
         {banner.map((val,i)=>(
            <div className="row" key={i}>
            <div className="  rounded-3  mx-auto pt-30 pb-30 px-lg-5  px-md-4 px-3 bg-dark ">
              <h2 className="h2-heading fs-2 lh-sm mb-3 text-start  text-white text-center" >Interested in learning about our work culture?</h2>
              <p className="h3-para fs-6 mb-2 lh-sm text-white">{val.desc} </p>
               <Link to="/contactus">
              <button className="fs-6 h3-para text-white text-decoration-underline mt-2">Contact Us </button>
               </Link>
            </div>
            {/* <div className="col-lg-6  col-11 mx-auto pt-30 pb-30  px-lg-5  px-md-4 px-3 bg-dark d-flex flex-column  justify-content-center">
              <h2 className="h2-heading fs-2 mb-3 lh-sm text-start text-white">{val.title2}</h2>
               <Link to="/request-quote">
              <button className="mt-1 h3-para  text-white text-start text-white text-decoration-underline">
                Explore Hiring Services{" "}
              </button>
               </Link>
            </div> */}
          </div>
          ))}
    </div>
  )
}

export default Banner